import { render, staticRenderFns } from "./HealingLogItem.vue?vue&type=template&id=48ac49db"
import script from "./HealingLogItem.vue?vue&type=script&lang=js"
export * from "./HealingLogItem.vue?vue&type=script&lang=js"
import style0 from "./HealingLogItem.vue?vue&type=style&index=0&id=48ac49db&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports